import { render } from "./iot-hub.vue?vue&type=template&id=fa43b9aa"
import script from "./iot-hub.vue?vue&type=script&lang=js"
export * from "./iot-hub.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__